module.exports = __webpack_public_path__ + "static/media/1003520.ac1f6d1b.png";